export default __webpack_public_path__ + "static/media/male3.524ec342.png";